import React from 'react';

export const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 100, height: 34 },
    default: { width: 140, height: 48 },
    large: { width: 200, height: 68 },
  };

  const { width, height } = sizes[size] || sizes.default;
  
  // Use transparent PNG logo
  const logoUrl = `/logo-transparent.png?v=20260329`;

  return (
    <div className={`${className}`} style={{ width: `${width}px`, height: `${height}px`, position: 'relative', margin: 0, padding: 0 }}>
      <img
        src={logoUrl}
        alt="Mothering"
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'contain',
          objectPosition: 'left center',
          margin: 0,
          padding: 0,
          display: 'block'
        }}
        onError={(e) => {
          console.error('Logo failed to load');
          e.target.style.display = 'none';
          if (e.target.nextElementSibling) {
            e.target.nextElementSibling.style.display = 'block';
          }
        }}
      />
      <span 
        style={{ 
          display: 'none',
          fontFamily: 'cursive',
          fontSize: size === 'small' ? '14px' : size === 'large' ? '24px' : '18px',
          color: '#06b6d4',
          fontWeight: 'bold'
        }}
      >
        Mothering
      </span>
    </div>
  );
};

export const LogoWithText = ({ className = "", showTagline = false }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <Logo size="default" />
    </div>
  );
};
